export default __webpack_public_path__ + "media/music/51a6ad8ce40ee24bb6315da8b2b6f882.mp3";